import StorefrontIcon from '@mui/icons-material/Storefront';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import { Chip } from '@mui/material';
import React, { FC } from 'react';
import { ArchType } from 'types/wizard';

interface IWizardArchTypeChipProps {
	archType: `${ArchType}` | '';
}

const WizardArchTypeChip: FC<IWizardArchTypeChipProps> = ({ archType }) => {
	const Icon =
		archType === ArchType.MT ? StorefrontIcon : SupervisorAccountIcon;
	return (
		<Chip
			icon={<Icon color="primary" />}
			variant="outlined"
			label={intl.tr(`wizard.phase.build.chip.${archType}`)}
			sx={{
				mb: {
					xs: 1
				},
				p: 0.5,
				mt: {
					sm: 0.5
				}
			}}
		/>
	);
};

export default WizardArchTypeChip;
